// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"71":"lasik-calculator","166":"quiz","309":"slider","582":"modal","737":"sliderhighlights","935":"scheduler"}[chunkId] + ".js?id=" + {"71":"94d7572190544ccd","166":"986da3e212c3fde0","309":"4c6f070b4117777e","582":"64e41f0a691ceef6","737":"3396907e52f75ac4","935":"567f1e9b29c9b747"}[chunkId] + "";
};